import { render, staticRenderFns } from "./PopUpAdd.vue?vue&type=template&id=b9b2a504&scoped=true"
import script from "./PopUpAdd.vue?vue&type=script&lang=js"
export * from "./PopUpAdd.vue?vue&type=script&lang=js"
import style0 from "./PopUpAdd.vue?vue&type=style&index=0&id=b9b2a504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b2a504",
  null
  
)

export default component.exports